import { TEvent } from "../Emitter"

const googleAPIKey = "AIzaSyBep4vxjbjq8Ng-OMvXDjsQgJJY6rEl8uw"

export type MarkerClickCallback = (content: string | null) => void;
export interface IMarker {
    lat: number;
    lng: number;
    title?: string;
    label?: string | IMarkerLabel;
    draggable?: boolean;
    icon?: string | IMarkerSymbol | MarkerIcon;
    infoWindowContent?: string;
    animation?: boolean;
    clickCallBack?: MarkerClickCallback;
}

export interface IMapApi {
    setCenter(lat: number, lng: number): void;
    setZoom(zoom: number): void;
    removeAllMarkers(): void;
    addMarker(marker: IMarker): Marker;
    addPolyline(points: { lat: number, lng: number }[]): void;
    removeAllPolylines(): void;
    removePolyline(index: number): void;
    redraw(): void;
    ChangeZoom: TEvent<number>;
    ChangeCenter: TEvent<{ lat: number, lng: number }>;
    ChangeMarkerPosition: TEvent<IMarker>;
}

export class MarkerIcons {
    static Default = "/images/StandardMarker.png";
    static Bus = "/images/BusMarker.png";
    static Point = "/images/PointMarker.png";
}

export interface IMarkerSymbol {
    path: string;
    fillColor?: string;
    fillOpacity?: number;
    scale?: number | any;
    strokeColor?: string;
    strokeWeight?: number;
    rotation?: number;
    text?: string;
    labelOrigin?: { x: number, y: number }
}

export interface IMarkerLabel {
    color?: string;
    fontFamily?: string;
    fontSize?: string;
    fontWeight?: string;
    text: string;
}

export interface MarkerIcon {
    url: string;
    size: { height: number, width: number }
}

let _promise: Promise<void>;



export abstract class Marker {
    lat: number;
    lng: number;
    abstract setPosition(lat: number, lng: number): void;
    abstract setTitle(label: string): void;
    abstract setInfoContent(content: string): void
    abstract setOnClickCallback(callback: MarkerClickCallback): void;
    abstract setIcon(icon: string | IMarkerSymbol | MarkerIcon): void;
    abstract setZIndex(z: number): void;
    abstract bringToTop(ms?: number): void;
}



class GMapMarker extends Marker {
    infoContent: string;
    onClickCallback: MarkerClickCallback;
    constructor(protected promise: Promise<google.maps.Map>) {
        super();
    }
    gmapMarker: google.maps.Marker;
    setPosition(lat: number, lng: number) {
        this.promise.then(() => {
            this.lat = lat;
            this.lng = lng;
            this.gmapMarker.setPosition(new google.maps.LatLng(lat, lng));
        });
    }
    setTitle(label: string) {
        this.promise.then(() => this.gmapMarker.setTitle(label));
    }
    setLabel(label: string | IMarkerLabel) {
        this.promise.then(() => this.gmapMarker.setLabel(label as (string | IMarkerLabel)));
    }
    setOnClickCallback(callback: MarkerClickCallback) {
        this.onClickCallback = callback;
    }
    setIcon(icon: string | IMarkerSymbol | MarkerIcon) {
        this.promise.then(() => {
            let iconObj = icon as MarkerIcon;
            if (iconObj.url) {
                this.gmapMarker.setIcon({
                    url: iconObj.url,
                    anchor: new google.maps.Point(iconObj.size.height / 2, iconObj.size.width / 2),
                    scaledSize: new google.maps.Size(iconObj.size.height, iconObj.size.width),
                });
            }
            else if (typeof icon === "string") {
                this.gmapMarker.setIcon(icon);
            }
            else {
                const { text, ...symbol } = icon as IMarkerSymbol;
                this.gmapMarker.setIcon({ ...symbol, labelOrigin: symbol.labelOrigin && new google.maps.Point(symbol.labelOrigin.x, symbol.labelOrigin.y) });
            }
        });
    }
    bringToTop(ms?: number) {
        this.promise.then(() => {
            var oldZindex = this.gmapMarker.getZIndex()!;
            this.gmapMarker.setZIndex(google.maps.Marker.MAX_ZINDEX + 1);
            if (ms !== undefined && ms > 0) {
                setInterval(() => this.gmapMarker.setZIndex(oldZindex), ms);
            }
        });
    }
    setZIndex(z: number) {
        this.promise.then(() => this.gmapMarker.setZIndex(z));
    }

    onClick = () => {
        if (this.infoContent) {
            if (this.onClickCallback) {
                this.onClickCallback(this.infoContent);
            } else {
                this.promise.then(map => {
                    let infowindow = new google.maps.InfoWindow({
                        content: this.infoContent
                    });
                    infowindow.open(map, this.gmapMarker);
                });
            }

        }
    }

    setInfoContent(content: string) {
        this.infoContent = content;
    }
}

function importGmaps(): Promise<void> {
    if (!_promise)
        _promise = new Promise<void>((resolve: () => void, reject: (err: any) => void) => {
            (window as any).__initGmaps = () => resolve();
            var script = document.createElement('script');
            script.type = 'text/javascript';
            script.src = `https://maps.googleapis.com/maps/api/js?v=3&key=${googleAPIKey}&callback=__initGmaps`;
            document.body.appendChild(script);
        });
    return _promise;
}

export function getGeoLocation(request: google.maps.GeocoderRequest) {
    return importGmaps().then(() => new Promise<{ lat: number, lng: number }>((resolve: (v: { lat: number, lng: number }) => void, reject: (err: any) => void) => {
        var geocoder = new google.maps.Geocoder();
        geocoder.geocode(request, (result, status) => {
            if (result.length == 0) {
                reject(status);
                return;
            }

            var latLng = result[0].geometry.location;
            if (status === google.maps.GeocoderStatus.OK) {
                resolve({ lat: latLng.lat(), lng: latLng.lng() });
            }
            else {
                reject(status);
            }
        });
    }));
}

export class GoogleMap implements IMapApi {
    ChangeZoom = new TEvent<number>();
    ChangeCenter = new TEvent<{ lat: number, lng: number }>();
    ChangeMarkerPosition = new TEvent<IMarker>();
    center: { lat: number, lng: number };
    private markers: GMapMarker[] = [];
    private polylines: google.maps.Polyline[] = [];

    constructor(private mapPromise: Promise<google.maps.Map>) {
        mapPromise.then(map => {
            map.addListener("zoom_changed", e => { this.ChangeZoom.emit(map.getZoom()) })
            map.addListener("center_changed", e => {
                const center = map.getCenter();
                this.ChangeCenter.emit({ lat: center.lat(), lng: center.lng() });
            });
        });
    }

    redraw() {
        this.mapPromise.then(map => {
            google.maps.event.trigger(map, "resize");
            map.setCenter(this.center);
        });
    }

    static init(mapElement: HTMLDivElement, lat: number, lng: number, zoom: number): IMapApi {
        return new GoogleMap(importGmaps().then(() => {
            var mapOptions: google.maps.MapOptions = {
                center: new google.maps.LatLng(lat, lng),
                scrollwheel: true,
                zoom: zoom,
                mapTypeId: google.maps.MapTypeId.ROADMAP,
                zoomControl: true,
            };
            return new google.maps.Map(mapElement, mapOptions);
        }));
    }


    setCenter(lat: number, lng: number) {
        this.mapPromise.then(map => {
            this.center = { lat, lng };
            map.setCenter(this.center);
        });
    }

    getCenter() {
        this.mapPromise.then(map => map.getCenter());
    }
    setZoom(zoom: number) {
        this.mapPromise.then(map => map.setZoom(zoom));
    }

    removeAllMarkers() {
        this.markers.forEach((m: GMapMarker) => m.gmapMarker.setMap(null));
        this.markers = [];
    }

    addPolyline(points: { lat: number, lng: number }[]) {
        var pol = new google.maps.Polyline({
            path: points.map(p => new google.maps.LatLng(p.lat, p.lng)),
            geodesic: true,
            strokeColor: '#FF0000',
            strokeOpacity: 1.0,
            strokeWeight: 2
        });
        this.polylines.push(pol);
    }
    removeAllPolylines() {
        this.polylines.forEach((p, i) => p.setMap(null));
        this.polylines = [];
    }
    removePolyline(index: number) {
        this.polylines[index].setMap(null);
        this.polylines.splice(index, 1);
    }

    addMarker(imarker: IMarker) {
        var promise = this.mapPromise;
        var m = new GMapMarker(promise);
        m.lat = imarker.lat;
        m.lng = imarker.lng;
        promise.then(map => {

            let position = new google.maps.LatLng(imarker.lat, imarker.lng);
            m.gmapMarker = new google.maps.Marker({ animation: imarker.animation ? google.maps.Animation.DROP : undefined, position });
            if (imarker.icon) m.setIcon(imarker.icon);
            if (imarker.draggable) {
                m.gmapMarker.setDraggable(true);
                m.gmapMarker.addListener("dragend", e => {
                    let newPosition = m.gmapMarker.getPosition()!;
                    m.lat = newPosition.lat();
                    m.lng = newPosition.lng();
                    this.ChangeMarkerPosition.emit(m);
                });
            }
            if (imarker.title)
                m.gmapMarker.setTitle(imarker.title);
            if (imarker.label)
                m.gmapMarker.setLabel(imarker.label);
            m.gmapMarker.setMap(map);
            m.gmapMarker.addListener('click', m.onClick)
            if (imarker.infoWindowContent) {
                m.setInfoContent(imarker.infoWindowContent);
            }
            if (imarker.clickCallBack) {
                m.setOnClickCallback(imarker.clickCallBack);
            }
            this.markers.push(m);
        });
        return m as Marker;
    }
}